import UserForm from '../components/UserForm';
import {graphql} from 'react-apollo';
import {SaveUserMutation, SaveUserMutationConfig} from '../qql-shared/mutations';

export default graphql(SaveUserMutation, SaveUserMutationConfig)(UserForm);



// WEBPACK FOOTER //
// ./src/containers/UserNew.js